/* eslint-disable multiline-comment-style */
import React from 'react';
import classnames from 'classnames';
export const Panel = ({ content, position, className, noPadding, style, open = true, }) => {
    var _a, _b;
    const contentClasses = classnames('Panel__content', className, {
        'Panel__content--noPadding': noPadding,
    });
    const panelClasses = classnames('Panel', className, {
        'Panel--left': position === 'left',
        'Panel--open': open,
    });
    return (React.createElement("div", { style: { width: open && ((_a = style === null || style === void 0 ? void 0 : style.width) !== null && _a !== void 0 ? _a : '340px') }, className: panelClasses },
        React.createElement("div", { style: { width: (_b = style === null || style === void 0 ? void 0 : style.width) !== null && _b !== void 0 ? _b : '340px' }, className: contentClasses }, content)));
};
//# sourceMappingURL=Panel.js.map